import { render, staticRenderFns } from "./DataFieldBar.vue?vue&type=template&id=2259cee8&scoped=true"
import script from "./DataFieldBar.vue?vue&type=script&lang=ts"
export * from "./DataFieldBar.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2259cee8",
  null
  
)

export default component.exports